<template>
  <div style="width:100%;padding-top: 60px">
    <div style="position: fixed;top: 0px;z-index: 999;width: 100%; background-color:#fff;">
      <div style="text-align:center">
        <van-button type="info" size="small" style="width: 15%;margin-top: 2%;" @click="show" v-if="inputForm.isDoTask">办理</van-button>
        <van-button type="info" size="small" style="margin-left: 3%;width: 15%;" @click="close">返回</van-button>
      </div>

      <div class="doTask" v-if="isshow">
        <div>
          <van-field name="radio" label="审批意见">
            <template #input>
              <van-radio-group v-model="auditForm.status" direction="horizontal">
                <van-radio name="同意">同意</van-radio>
                <van-radio name="不同意">不同意</van-radio>
              </van-radio-group>
            </template>
          </van-field>
        </div>
        <div>
          <van-cell-group>
            <van-field v-model="auditForm.message" rows="2" autosize label="审批说明" type="textarea" placeholder="请输入审批说明" />
          </van-cell-group>
        </div>
        <div style="text-align:center">
          <van-button type="info" size="small" style="width: 15%;margin-top: 2%;" @click="submitTask()">提交</van-button>
        </div>
      </div>
    </div>

    <van-collapse v-model="activeNames">
      <div style="padding-left: 16px">
        <van-field v-model="inputForm.scatterOutboundNo" label="散果/残果出库单编号" label-width="130px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="inputForm.outboundDate" label="出库日期" label-width="130px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="inputForm.packAddressName" label="冷库" label-width="130px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="inputForm.secondaryColdStorageName" label="二级冷库" label-width="130px" readonly input-align="left"
                   :border="false" autosize rows="1" type="textarea"/>
        <van-field v-model="inputForm.officeName" label="包装小组" label-width="130px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="inputForm.operatorName" label="包装组长" label-width="130px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="inputForm.varietyName" label="出库品种" label-width="130px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="inputForm.scatterSourceLabel" label="散果残果出库来源" label-width="130px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="inputForm.varietyLevelLabel" label="出库果品类型" label-width="130px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="inputForm.destinationTypeLabel" label="出库去向" label-width="130px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="inputForm.brandName" :label="inputForm.destinationType === '1' ? '出库品牌' : '打包品牌'" label-width="130px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-show="inputForm.destinationType === '1'" v-model="inputForm.dispatchNo" label="物流发车单编号" label-width="130px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="inputForm.departDate" label="发车日期" label-width="130px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-show="inputForm.varietyLevel === '5' && inputForm.destinationType === '2'" v-model="inputForm.packWorkshopNo" label="包装车间编号" label-width="130px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="inputForm.createByName" label="制单人" label-width="130px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="inputForm.createDate" label="制单日期" label-width="130px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />


        <van-collapse-item :title="inputForm.varietyLevel === '5' ? '散果出库信息' : '残果出库信息'" name="1">
          <div v-show="inputForm.destinationType !== '2'">
            <van-field v-model="inputForm.weighFlagLabel" label="称重方式" label-width="130px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
            <van-field v-show="inputForm.weighFlag !== '1'" v-model="inputForm.tareWeight" :formatter="formatter" label="空车过磅重量（斤）" label-width="130px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
            <van-field v-show="inputForm.weighFlag !== '1'" v-model="inputForm.truckWeight" :formatter="formatter" label="装车过磅总重（斤）" label-width="130px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
            <van-field v-show="inputForm.weighFlag !== '0'" v-model="inputForm.totalWeightIncludeTrayPack" :formatter="formatter" label="含托盘总重（斤）" label-width="130px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
            <van-field v-show="inputForm.weighFlag !== '0'" v-model="inputForm.totalTrayWeight" :formatter="formatter" label="托盘总重（斤）" label-width="130px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
            <van-field v-model="inputForm.totalWeightIncludePack" :formatter="formatter" label="含筐总重（斤）" label-width="130px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
            <van-field v-model="inputForm.totalOutboundNum" label="出库总件数（筐）" label-width="130px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
            <van-field v-model="inputForm.totalPackWeight" :formatter="formatter2" label="出库包装材料总重（斤）" label-width="130px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
            <van-field v-model="inputForm.totalWeightExcludePack" :formatter="formatter2" label="不含筐总重（斤）" label-width="130px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
          </div>

          <div style=" margin-bottom: 10px; margin-top: 10px; padding-left: 16px">
            <p style="display: block; color: #4caedc" @click="viewDetail()">查看{{inputForm.varietyLevel === '5' ? '散果出库明细' : '残果出库明细'}}</p>
          </div>
        </van-collapse-item>
        <van-collapse-item title="过磅信息" name="2">
          <van-field v-model="inputForm.weighFee" label="过磅费（元）" :formatter="formatter" label-width="130px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
          <div style="padding-left: 16px; font-size: 14px;" v-show="inputForm.weighFeeAttachList.length > 0">
            <p style="color: #AAA">过磅小票</p>
            <p style="display: block; color: #4caedc" v-for="(file,index) in inputForm.weighFeeAttachList" :key="index" @click="$viewAttach(file)">{{file.name}}</p>
          </div>
          <van-field v-model="inputForm.remark" label="备注" label-width="130px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />

        </van-collapse-item>
        <van-collapse-item title="发车信息" name="3" v-show="inputForm.dispatchId && inputForm.dispatchId !== '0'">
          <van-field v-model="inputForm.consignName" label="收货地点" label-width="130px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
          <van-field v-model="inputForm.consignAddress" label="收货地点详细地址" label-width="130px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
          <van-field v-model="inputForm.truckDriverName" label="货车司机" label-width="130px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
          <van-field v-model="inputForm.truckDriverPhone" label="货车司机联系方式" label-width="130px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
          <van-field v-model="inputForm.plateNo" label="境内运输车牌号" label-width="130px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
          <div style="padding-left: 16px; font-size: 14px;" v-show="inputForm.carFrontAttachList && inputForm.carFrontAttachList.length > 0">
            <p style="color: #AAA">车头照片</p>
            <p style="display: block; color: #4caedc" v-for="(file,index) in inputForm.carFrontAttachList" :key="index" @click="$viewAttach(file)">{{file.name}}</p>
          </div>
          <div style="padding-left: 16px; font-size: 14px;" v-show="inputForm.carBodyAttachList && inputForm.carBodyAttachList.length > 0">
            <p style="color: #AAA">车身照片</p>
            <p style="display: block; color: #4caedc" v-for="(file,index) in inputForm.carBodyAttachList" :key="index" @click="$viewAttach(file)">{{file.name}}</p>
          </div>
          <div style="padding-left: 16px; font-size: 14px;" v-show="inputForm.carTailAttachList && inputForm.carTailAttachList.length > 0">
            <p style="color: #AAA">车尾照片</p>
            <p style="display: block; color: #4caedc" v-for="(file,index) in inputForm.carTailAttachList" :key="index" @click="$viewAttach(file)">{{file.name}}</p>
          </div>
        </van-collapse-item>

      </div>

    </van-collapse>
    <process-record :procInsId="procInsId"></process-record>
  </div>
</template>

<script>
import processRecord from "../../../../../components/processRecord/processRecord.vue";
import TaskService from "../../../../../api/flowable/TaskService";
import ProcessService from "../../../../../api/flowable/ProcessService";
import QueryInfoService from "@/api/system/queryInfoService";
export default {
  name: "ItsStockRawWashOutBound",
  data(){
    return {
      activeNames: ['1','2','3'],
      isshow: false,
      radio: '',
      auditForm: {
        message: '',
        type: '_flow_agree',
        status: '同意',
        userIds: null,
        assignee: null
      },
      taskId: '',
      taskDefKey: '',
      procInsId: '',
      procDefId: '',
      type:'',
      inputForm:{
        attachList: [],
        isDoTask: false,
        isLastTask: false,
      },
      flowTable: 'its_stock_scatter_outbound'
    }
  },
  components: {
    processRecord
  },
  created() {
    let query = this.$route.query;
    let id = query.id
    this.taskId = query.taskId
    this.taskDefKey = query.taskDefKey
    this.procInsId = query.procInsId
    this.procDefId = query.procDefId
    this.type = query.type || ''
    this.init(id)
  },
  methods: {
    show() {
      this.isshow = !this.isshow
    },
    init(id) {
      this.$flow.queryById(id, '/its/stock/itsStockScatterOutbound/queryById').then(({ data }) => {
        this.inputForm = data
        if(!data.attachList) {
          this.inputForm.attachList = []
        }
        this.inputForm.createDate = data.createDate.slice(0, 10)
        this.getDict([
          ['its_base_variety_level', 'varietyLevel'],
          ['its_scatter_source_type', 'scatterSource'],
          ['its_order_weigh_flag', 'weighFlag'],
          ['its_scatter_outbound_destination_type', 'destinationType'],
        ])
        this.updateDictNames(this.inputForm.detailList,{its_base_variety_level:'varietyLevel'})
      }).catch(e => {
        console.log(e)
      })
    },
    getDict(dicts){
      new QueryInfoService().getDictMap().then(({data}) => {
        dicts.map(([dictType, formField]) => {
          this.$set(this.inputForm, `${formField}Label`, data[dictType].find(item=>item.value==this.inputForm[formField]).label);
        });
      }).catch(e => {
        console.log(e)
      })
    },
    async updateDictNames(dataList, dictTypeList) {
      const {data} = await new QueryInfoService().getDictMap();
      const promises = dataList.map(async (item) => {
        for (const [dictType, formField] of Object.entries(dictTypeList)) {
          if (data[dictType] && Array.isArray(data[dictType])) {
            const dictItem = data[dictType].find(d => d.value === item[formField]);
            if (dictItem) {
              this.$set(item, `${formField}Label`, dictItem.label);
            }
          }
        }
      });
    },
    close() {
      if(this.type !== '') {
        this.$router.back()
      } else {
        //Android、iOS支持PC不支持
        dd.biz.navigation.close({
          onSuccess: function (result) {
          },
          onFail: function (err) {
          }
        })
        // //Android、iOS不支持，PC支持
        dd.biz.navigation.quit({
          message: "quit message",
          onSuccess: function (result) {
          },
          onFail: function () {
          }
        })
      }
    },
    submitTask() {
      if (this.auditForm.status == '同意') {
        this.agree()
      } else {
        this.reject()
      }
    },
    agree() {
      let _this = this
      _this.$dialog.confirm({
        title: '系统提醒',
        message: '您确认提交吗？',
      }).then(() => {
        _this.$toast.loading({
          message: '加载中...',
          forbidClick: true,
        });
        let vars = {}
        // vars = { ...vars, ..._this.inputForm }
        // _this.auditForm.message = _this.inputForm.remarks
        _this.auditForm.type = _this.inputForm.isLastTask?'_flow_approval':'_flow_agree'
        new TaskService().audit({
          taskId: _this.taskId,
          taskDefKey: _this.taskDefKey,
          procInsId: _this.procInsId,
          procDefId: _this.procDefId,
          vars: vars,
          comment: _this.auditForm,
          assignee: _this.auditForm.assignee
        }).then(({ data }) => {
          _this.$toast.clear();
          _this.$toast.success('提交成功');
          //更新数据库状态
          let form = {
            id: _this.inputForm.id,
            flowType: _this.inputForm.isLastTask ? 4 : 2,
            formKey: _this.formKey,
            flowTable: _this.flowTable,
          }
          // _this.inputForm.flowType = _this.inputForm.isLastTask?4:2;
          _this.$flow.startFlow(form, '/its/comm/flow/startFlow');

          setTimeout(function () {
            _this.close()
          }, 800)
        })
      }).catch(() => {
      })
    },
    reject() {
      let _this = this
      _this.$dialog.confirm({
        title: '系统提醒',
        message: '您确认提交吗？',
      }).then(() => {
        _this.$toast.loading({
          message: '加载中...',
          forbidClick: true,
        });
        new ProcessService().stop(_this.procInsId, _this.auditForm.message).then(({ data }) => {
          _this.$toast.clear();
          _this.$toast.success('提交成功');
          //更新数据库状态
          // _this.inputForm.flowType = 3;
          let form = {
            id: _this.inputForm.id,
            flowType: 3,
            formKey: _this.formKey,
            flowTable: _this.flowTable,
          }
          _this.$flow.startFlow(form, '/its/comm/flow/startFlow');

          setTimeout(function () {
            _this.close()
          }, 800)
        })
      }).catch(() => {
      })
    },
    formatter(value){
      return Number(value).toFixed(2)
    },
    formatter2(value){
      return Number(value).toFixed(4)
    },
    viewDetail(){
      this.$router.push({
        path: '/ItsStockScatterOutBoundDetail',
        query: {
          data: JSON.stringify(this.inputForm.detailList),
          filterParams: JSON.stringify({
            weighFlag: this.inputForm.weighFlag,
            destinationType: this.inputForm.destinationType,
            varietyLevel: this.inputForm.varietyLevel
          })
        }
      })
    },
  }
}
</script>

<style scoped>

</style>
